import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { ClipboardList, Home, LogOut, RefreshCw, User, Wallet } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

const navItems = [
  { label: 'Dashboard', path: '/dashboard', icon: Home },
  { label: 'Orders', path: '/orders', icon: ClipboardList },
  { label: 'Replace', path: '/replacements', icon: RefreshCw },
  { label: 'Wallet', path: '/wallet', icon: Wallet },
  { label: 'Profile', path: '/profile', icon: User },
];

const Layout: React.FC = () => {
  const { user, logout } = useAuth();
  const firstName = user?.name?.split(' ')?.[0] || 'Technician';

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-mark">M</div>
          <div>
            <div className="brand-title">Minto Tech</div>
            <div className="brand-subtitle">Technician</div>
          </div>
        </div>

        <nav className="nav-list">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                <Icon size={17} />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="profile-chip">
            <div className="avatar">{user?.name?.charAt(0)?.toUpperCase() || 'T'}</div>
            <div>
              <div className="profile-name">{user?.name}</div>
              <div className="profile-mobile">{user?.mobile}</div>
            </div>
          </div>
          <button className="logout-button" onClick={logout}>
            <LogOut size={16} />
            Logout
          </button>
        </div>
      </aside>

      <main className="main-area">
        <header className="topbar">
          <div className="mobile-app-title">
            <div className="avatar">{firstName.charAt(0).toUpperCase()}</div>
            <div>
              <span>Welcome</span>
              <strong>{firstName}</strong>
            </div>
          </div>
          <div className="desktop-topbar-title">Technician workspace</div>
          <button className="topbar-logout" onClick={logout}>
            <LogOut size={16} />
            <span>Logout</span>
          </button>
        </header>
        <section className="page-container">
          <Outlet />
        </section>
      </main>

      <nav className="bottom-nav" aria-label="Technician navigation">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `bottom-nav-link ${isActive ? 'active' : ''}`}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};

export default Layout;
